import { defineComponent as ee, mergeModels as D, useModel as oe, useSlots as te, getCurrentInstance as ae, computed as c, useTemplateRef as F, ref as K, inject as ne, watch as le, provide as ie, onMounted as re, nextTick as se, useId as ue, createBlock as T, openBlock as i, unref as t, withCtx as O, createElementVNode as C, mergeProps as H, createElementBlock as d, createCommentVNode as r, renderSlot as k, resolveDynamicComponent as de, normalizeClass as s, createVNode as h, createTextVNode as U, toDisplayString as q } from "vue";
import l from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Menu/menu.js";
import { MenuInjectionKey as fe, MenuItemsKey as ce } from "./Menu.vue2.js";
import me from "../Checkbox.vue2.js";
import ve from "./MenuItemAction.vue2.js";
import { AngleLeftIcon as pe } from "../../packages/icons/dist/esm/icons/angle-left-icon.js";
import { AngleRightIcon as ye } from "../../packages/icons/dist/esm/icons/angle-right-icon.js";
import { UpRightFromSquareIcon as Ie } from "../../packages/icons/dist/esm/icons/up-right-from-square-icon.js";
import { CheckIcon as ke } from "../../packages/icons/dist/esm/icons/check-icon.js";
import { isDefined as b } from "../../node_modules/.pnpm/@vueuse_shared@13.1.0_vue@3.5.13_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
import { useChildrenTracker as he } from "../../use/children-tracker.js";
import be from "../../helpers/TeleportCopy.vue2.js";
import { useOUIAProps as ge } from "../../helpers/ouia.js";
const Be = ["role"], Me = ["name", "value"], we = Symbol("MenuItemInjectionKey"), Fe = /* @__PURE__ */ ee({
  name: "PfMenuItem",
  inheritAttrs: !1,
  __name: "MenuItem",
  props: /* @__PURE__ */ D({
    name: {},
    value: {},
    to: {},
    check: { type: Boolean },
    checkName: {},
    active: { type: Boolean },
    loadButton: { type: Boolean },
    loading: { type: Boolean },
    component: { default: "button" },
    componentAttrs: {},
    disabled: { type: Boolean },
    description: {},
    externalLink: { type: Boolean },
    selected: { type: Boolean, default: void 0 },
    focused: { type: Boolean },
    danger: { type: Boolean },
    direction: {},
    onPath: { type: Boolean },
    download: {},
    target: {},
    referrerpolicy: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  }, {
    favorited: { type: Boolean, default: void 0 },
    favoritedModifiers: {}
  }),
  emits: /* @__PURE__ */ D(["click", "show-flyout"], ["update:favorited"]),
  setup(L, { expose: z, emit: G }) {
    const a = L, J = ge({ id: a.ouiaId, safe: a.ouiaSafe }), f = oe(L, "favorited"), R = G, m = te(), v = ae(), g = c(() => a.value === void 0 ? v == null ? void 0 : v.vnode.key : a.value), Q = F("elRef"), $ = F("menuItemRef"), y = K(a.focused), o = ne(fe);
    he(ce, {
      element: Q,
      disabled: c(() => a.disabled),
      focused: y,
      favorited: f,
      focus: A
    }), le(() => a.focused, (e) => {
      y.value = e;
    }), ie(we, {
      disabled: a.disabled,
      itemId: g
    }), re(() => {
      if (!o)
        throw new Error("MenuItems can only be used inside Menu components");
      y.value && se(A);
    });
    const u = c(() => a.to ? "a" : a.check ? "label" : a.component), W = c(
      () => a.onPath
      /*  || (itemId.value && menu?.drilldownItemPath?.includes(itemId.value)) */
    ), P = c(() => {
      var e, n;
      return b(a.selected) ? a.selected : (e = o == null ? void 0 : o.selected) != null && e.value && Array.isArray(o.selected.value) ? o.selected.value.includes(a.value) : ((n = o == null ? void 0 : o.selected) == null ? void 0 : n.value) === a.value;
    }), X = c(() => b(a.active) ? a.active ? "page" : null : b(g.value) && b(o == null ? void 0 : o.activeItemId) ? g.value === (o == null ? void 0 : o.activeItemId) : null), Y = K(null), p = c(() => v && v === (o == null ? void 0 : o.flyout.value));
    function Z() {
      !o || o.state.disableHover || (m["flyout-menu"] ? S(!0) : o.flyout.value = null);
    }
    function S(e) {
      o && (!p.value && e ? o.flyout.value = v : p.value && !e && (o.flyout.value = null), R("show-flyout"));
    }
    const E = ue();
    function x(e) {
      N(e), m["flyout-menu"] && _(e);
    }
    function N(e) {
      var n;
      (n = o == null ? void 0 : o.onSelect) == null || n.call(o, e, g.value), R("click", e);
    }
    function _(e) {
      const n = e.key, I = e.target, B = e.type;
      (n === " " || n === "Enter" || n === "ArrowRight" || B === "click") && (e.stopPropagation(), !p.value && I instanceof HTMLElement && (S(!0), Y.value = I)), (n === "Escape" || n === "ArrowLeft") && p.value && (e.stopPropagation(), S(!1));
    }
    function A() {
      $.value && ($.value.focus(), $.value.scrollIntoView({
        behavior: "auto",
        block: "nearest"
      }));
    }
    return z({
      focus: A,
      focused: y
    }), (e, n) => {
      var I, B, V, j;
      return i(), T(be, {
        disabled: !((B = (I = t(o)) == null ? void 0 : I.favoriteList.value) != null && B.$el) || !f.value,
        to: (j = (V = t(o)) == null ? void 0 : V.favoriteList.value) == null ? void 0 : j.$el
      }, {
        default: O(({ copy: M }) => [
          C("li", H({ ref: "elRef" }, { ...t(J), ...e.$attrs }, {
            class: [t(l).menuListItem, {
              [t(l).modifiers.disabled]: e.disabled,
              [t(l).modifiers.currentPath]: W.value,
              [t(l).modifiers.load]: e.loadButton,
              [t(l).modifiers.loading]: e.loading,
              [t(l).modifiers.focus]: y.value,
              [t(l).modifiers.danger]: e.danger
            }],
            role: e.check ? "menuitem" : "none",
            onMouseover: Z
          }), [
            !M && e.name ? (i(), d("input", {
              key: 0,
              type: "hidden",
              name: e.name,
              value: e.value
            }, null, 8, Me)) : r("", !0),
            (i(), T(de(u.value), H({ ref: "menuItemRef" }, e.componentAttrs, {
              tabindex: "-1",
              class: [t(l).menuItem, { [t(l).modifiers.selected]: P.value && !e.check }],
              "aria-current": X.value,
              disabled: e.disabled && !e.check && u.value !== "a" || void 0,
              role: !m["flyout-menu"] && !e.check ? "menuitem" : void 0,
              for: M || e.check ? void 0 : t(E),
              href: u.value === "a" ? e.to : void 0,
              "aria-disabled": u.value === "a" && e.disabled ? e.disabled : void 0,
              "aria-expanded": e.onPath || p.value || void 0,
              type: u.value === "button" ? "button" : void 0,
              target: u.value === "a" ? e.target : void 0,
              referrerpolicy: u.value === "a" ? e.referrerpolicy : void 0,
              download: u.value === "a" ? e.download : void 0,
              onClick: n[1] || (n[1] = (w) => !e.check && x(w))
            }), {
              default: O(() => [
                C("span", {
                  class: s(t(l).menuItemMain)
                }, [
                  e.direction === "up" ? (i(), d("span", {
                    key: 0,
                    class: s(t(l).menuItemToggleIcon)
                  }, [
                    h(t(pe), { "aria-hidden": "" })
                  ], 2)) : r("", !0),
                  m.icon ? (i(), d("span", {
                    key: 1,
                    class: s(t(l).menuItemIcon)
                  }, [
                    k(e.$slots, "icon")
                  ], 2)) : r("", !0),
                  e.check ? (i(), d("span", {
                    key: 2,
                    class: s(t(l).menuItemCheck)
                  }, [
                    h(me, {
                      id: M ? void 0 : t(E),
                      name: M ? void 0 : e.checkName,
                      component: "span",
                      "model-value": P.value,
                      disabled: e.disabled,
                      onChange: n[0] || (n[0] = (w) => N(w))
                    }, null, 8, ["id", "name", "model-value", "disabled"])
                  ], 2)) : r("", !0),
                  C("span", {
                    class: s(t(l).menuItemText)
                  }, [
                    k(e.$slots, "default", {}, () => [
                      U(q(e.value), 1)
                    ])
                  ], 2),
                  e.externalLink ? (i(), d("span", {
                    key: 3,
                    class: s(t(l).menuItemExternalIcon)
                  }, [
                    h(t(Ie), { "aria-hidden": "" })
                  ], 2)) : r("", !0),
                  m["flyout-menu"] && e.direction === "down" ? (i(), d("span", {
                    key: 4,
                    class: s(t(l).menuItemToggleIcon)
                  }, [
                    h(t(ye), { "aria-hidden": "" })
                  ], 2)) : r("", !0),
                  P.value ? (i(), d("span", {
                    key: 5,
                    class: s(t(l).menuItemSelectIcon)
                  }, [
                    h(t(ke), { "aria-hidden": "" })
                  ], 2)) : r("", !0)
                ], 2),
                (m.description || e.description) && e.direction !== "up" ? (i(), d("span", {
                  key: 0,
                  class: s(t(l).menuItemDescription)
                }, [
                  C("span", null, [
                    k(e.$slots, "description", {}, () => [
                      U(q(e.description), 1)
                    ])
                  ])
                ], 2)) : r("", !0)
              ]),
              _: 2
            }, 1040, ["class", "aria-current", "disabled", "role", "for", "href", "aria-disabled", "aria-expanded", "type", "target", "referrerpolicy", "download"])),
            p.value ? k(e.$slots, "flyout-menu", { key: 1 }) : r("", !0),
            k(e.$slots, "actions"),
            t(b)(f.value) ? (i(), T(ve, {
              key: 2,
              icon: "favorites",
              favorited: f.value,
              "aria-label": f.value ? "starred" : "not starred",
              tabindex: "-1",
              "action-id": "fav",
              onClick: n[2] || (n[2] = (w) => f.value = !f.value)
            }, null, 8, ["favorited", "aria-label"])) : r("", !0)
          ], 16, Be)
        ]),
        _: 3
      }, 8, ["disabled", "to"]);
    };
  }
});
export {
  we as MenuItemInjectionKey,
  Fe as default
};
